import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, type Theme } from '@mui/material';

//siblings
import {ServiceBase, ServiceWindow} from '../../components/service';
import { extendedstyles } from '../appstyles';
import { clone, setConfig, tuples } from '../../core';
import { bizpost } from '../../ajax';
import { GridPanel } from '../../components/grid';
import { Fab } from '@mui/material';
import ContentAdd from '@mui/icons-material/Add';
import { ProgressDialog } from '../../components/dialogs';
import { Data } from '../../components/base';
import { formatDate,formatSource } from '../../components/renderers/formats';
import InspectorDialog from '../custom/InspectorDialog';

const s:any ={};


class Inspector extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props: any) {
      super(props);
      //const { title, service } = this.props;
      //console.log('construct title,service', title, service);
      this.state = {
        title: 'inspector', 
        url: '/biz',
        params: {},
        action: '', //'search': can be add,edit,delete,search,...other
        actions: [],
        filter: {},
        loading: false,
        wizmode: 'add',
        record: {},
        data: [],
        recordCount: 0,
        page: 0,
        rowsPerPage: 10,
        pageMode: 'local',
        order: 'desc',
        orderBy: 'dcd',
        refid: null,
        fwopen: false,
      };
    }

  configuration = () => {
    const config = {
      service:{
        name:'inspector',
        title:'Monitor',
        key:'rid',
        num: true,
        fields:['rid','nam','usk','usi','unm','eni','ens','enc','iti','itc','iri','irc','sci','scc','mbn','eml','des','dsc','dcd','exi','sts','ast','stp'],
        params: {nam:'Name',shc:'Code',dsc:'Description',usi:'User',iti:'Monitor Type',iri:'Monitor Role',sci:'Sector',sts:'Status'},
        grid: [['nam','Name'],['mbn','Phone'],['eml','Email'],['des','Designation'],['enc','Entity'],['ast','Status'],['stp','Stamp']],
        bar: {pag:true,btn:['add','edit','del','view']},
        menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
        eform:[
              {id:'iti',label:'Monitor Type',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'inspectortype'},chs:['nam','usi']},
              {id:'nam',label:'Name',type:'tf',req:0,ops:{},pns:['iti']},
              {id:'usi',label:'User',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'user'}},
              {id:'iri',label:'Monitor Role',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'inspectorrole'}},
              {id:'sci',label:'Sector',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'sector'}},
              {id:'mbn',label:'Mobile',type:'ta',req:1,ops:{type:'tel'}},
              {id:'eml',label:'Email',type:'tf',req:1,ops:{type:'email'},},
              {id:'des',label:'Designation',type:'tf',req:0,ops:{}},
              {id:'dsc',label:'Description',type:'tf',req:0,ops:{}},
              {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{}},
              {id:'sts',label:'Record Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
            ],
      },
      create:true,
      actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
      panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
      formatters: {grid: {exi: (value: any) => value ? JSON.stringify(value) : ''}}
    };
    return config;
  }

  getServiceConfig = () => {
    //const { configuration } = this.props;

    const extraconfig = Object.assign(
      {},
      this.configuration(),
      //configuration()
    );
    const config = setConfig(extraconfig);
    const ServiceConfig = clone(config);
    const SData = ServiceConfig.service;
    return { svc: ServiceConfig, svd: SData };
  };

  setPageMode = () => {
    const { svc, svd } = this.getServiceConfig();
    const { pageMode = 'local' } = svd;
    console.log('setPageMode.pagemode:...', pageMode, svd);
    //console.log("service config",this.getServiceConfig())
    this.setState({ pageMode });
  };

  componentDidMount() {
    // const {svc,svd} = this.getServiceConfig();
    // const {pageMode='local'} = svd;
    // console.log('mounted.pagemode:...',pageMode,svd);

    // this.setState({pageMode});
    this.setPageMode();
    console.log('refreshing...');
    this.refresh();
  }

  refresh = async (inparams?: any) => {
      console.log('refresh called');
      try {
        const { svc, svd } = this.getServiceConfig();
        const { pageMode = 'local' } = svd;
        // //TODO: store final paramlist in state on success for reuse of refresh
        const { params, rowsPerPage, page } = this.state;
        //const {code,service} = this.props;
        const { service } = this.props;
  
        this.startLoading();
        const pos = page * rowsPerPage;
        const plm = rowsPerPage;
        const paging = pageMode === 'remote' ? { pos, plm } : {};
        let extraparams = inparams || params; //{}
        let baseparams = {
          s: service,
          a: 'find',
          ...extraparams,
          ...paging,
        }; /*shc:code,/*,pos:pos,plm:plm*/
        console.log('Refresh params', baseparams);
        const response = await bizpost(baseparams);
        //TODO: build rows and add to state??
        this.setState({ data: response.sd, recordCount: +response.rc }); //,params:baseparams
      } catch (error) {
        // console.log(error);
        this.setState({ data: [] });
        this.setState({ recordCount: 0 });
        console.log('refresh error:', error);
        const errorx: any = error || {};
        this.props.showNotification(
          errorx.message || 'request failed',
          errorx.type || 'warn',
          errorx.title || 'Loading Error'
        );
      } finally {
        if (this.state.loading) this.stopLoading();
      }
    };

    startLoading = () => {
    this.setState({ loading: true });
  };


  onSearch = async (service: string, query: string) => {
      console.log('search called');
      try {
        //TODO: store final paramlist in state on success for reuse of refresh
        const { params } = this.state;
        //const {code,service} = this.props;
        const { service } = this.props;
        this.startLoading();
        let extraparams = { qry: query, ...params }; //params||params; //{}
        let baseparams = {
          s: service,
          a: 'search',
          ...extraparams,
        }; /*shc:code,/*,pos:pos,plm:plm*/
        const response = await bizpost(baseparams);
        console.log('service response ', response);
        //TODO: build rows and add to state??
        this.setState({ data: response.sd, recordCount: +response.rc }); //,params:baseparams
      } catch (error) {
        // console.log(error);
        this.setState({ data: [] });
        this.setState({ recordCount: 0 });
        console.log('search error:', error);
        const errorx: any = error || {};
        this.props.showNotification(
          errorx.message || 'request failed',
          errorx.type || 'warn',
          errorx.title || 'Loading Error'
        );
      } finally {
        if (this.state.loading) this.stopLoading();
      }
    };

  stopLoading = () => {
    this.setState({ loading: false });
  };

  handleRecord = (record: any) => () => {
    console.log('in handleRecord', record.action);
    const actions = this.props.actionSet || {};
    const { url } = this.state;
    let action =
      actions[record.action] || Data.actions[record.action] || 'Process';
    const { handleRecord } = this.props;
    const xrecord =
      typeof handleRecord == 'function' ? handleRecord(record) : record;
    if (xrecord)
      this.setState({
        record: xrecord.item,
        wizmode: xrecord.action,
        action: action,
        url: xrecord.url || url,
        fwopen: true,
      });
  };

  handleDelete = (record: any) => () => {
    this.setState({ record: record, wizmode: 'delete', fwopen: true });
  };

  handleClose = () => {
    this.setState({ fwopen: false });
  };

  onResponse = (status: any, response: any) => {
    // const {wizmode} = this.state;
    console.log('onResponse', response);
    //TODO
    if (status) {
      this.handleClose();
      this.refresh();
    }
  };

  formatStatus = (type: string) => (id: any) => {
    let name = ['disabled', 'active', 'stopped'][id] || 'unknown';
    return name;
  };

  statusname = (id: any) => {
    return Data.statuses.list[id] || 'unknown';
  };

  rowActions = (id: any, rec: any) => {
    return (
      [
        ['view', 'delete'],
        ['view', 'edit', 'delete'],
        ['view', 'edit', 'delete'],
      ][rec.sts] || ['view']
    );
  };

  onPageChange = (event: any, page: any) => {
    console.log('in SB.onPageChange', page);
    this.setState({ page });
    //this.refresh();
  };

  onRowsPerPageChange = (event: any) => {
    console.log('in SB.onRowsPerPageChange');
    this.setState({ rowsPerPage: event.target.value });
  };

  filterColumns = (rows: any[]) => {
    // const {rows} = this.props;
    const cols: any[] = rows.map((row: any) => row.id); //this.state;
    return rows.filter((row: any) => cols.includes(row.id));
  };

  setColumns = (event: any, fcols: any) => {
    this.setState({ cols: fcols });
  };

  render() {
    const {service,code,showNotification,setPage,setHome,classes, theme} = this.props;
    const {
      url,
      action,
      loading,
      wizmode,
      fwopen,
      record,
      data,
      recordCount,
      pageMode: pmode,
      page,
      rowsPerPage,
      order,
      orderBy,
    } = this.state;
    const cancreate = true;
    const fabstyle = { position: 'fixed', right: 20, bottom: 20 };
    const isform = action !== '';
    const stitle ='Monitor';
    const extraconfig = Object.assign(
          {},
          this.configuration()
    );
    //console.log('extraconfig',service,extraconfig);
    const config = setConfig(extraconfig); //
    const ServiceConfig = clone(config);
        //console.log('ServiceConfig',service,ServiceConfig);
    const SData = ServiceConfig.service; //ServiceData['service'];
    if (!SData) this.props.setHome();

    const Columns = tuples(SData.grid);
        if (Columns.length > 0) Columns.push({ k: 'ACTION', v: '' });
        //console.log('tuples',Columns,Columns.length);
        const cm = SData.cols;
        const fmformatters = {
          sts: this.formatStatus('form'),
          dcd: formatDate,
          stp: formatDate,
          src: formatSource,
        };
        const gdformatters = {
          sts: this.formatStatus('grid'),
          dcd: formatDate,
          stp: formatDate,
          src: formatSource,
        };

    //add formatters from config and from class to base formatters
    const cformatters = ServiceConfig.formatters || {};
    const { form: cfformatters, grid: cgformatters } = cformatters;
    const _formformatters = Object.assign(
      {},
      fmformatters,
      cfformatters,
    {}
    );
    const _gridformatters = Object.assign(
      {},
      gdformatters,
      cgformatters,
        {}
    );
    const _rowActions = this.rowActions;
    //const _handleRecord = this.handleRecord;// || this.handleRecord;
    
    const newrecord = { item: { sts: 1, a: 'add' }, action: 'add' };
    const { pageMode = 'local' } = SData;
    const panels = ServiceConfig.panels;

    return (
      <Box>
        {cancreate && (
          <Fab
            sx={{...s.fixedfab,...fabstyle}}
            style={{
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.secondary.contrastText,
            }}
            onClick={this.handleRecord(newrecord)}
            //sx={fabstyle}
          >
            <ContentAdd sx={{...s.actionfab}} />
          </Fab>
        )}
        {isform && fwopen && (
          <InspectorDialog
            open={fwopen}
            mode={wizmode}
            code={code}
            title={`${action} ${stitle}`}
            service={service}
            url={url}
            panels={panels}
            actions={_rowActions}
            actionSet={this.props.actionSet}
            rowActions={this.props.rowActions}
            record={record}
            data={data}
            sdata={SData}
            sconfig={ServiceConfig}
            formatters={_formformatters}
            onChange={this.props.onChange}
            refresh={this.refresh}
            onSubmit={this.props.onSubmit}
            onResponse={this.onResponse}
            onClose={this.handleClose.bind(this)}
            showNotification={showNotification}

          />
        )}
        {loading && (
          <ProgressDialog
            open={loading}
            loading={loading}
            startLoading={this.startLoading} //.bind(this)
            stopLoading={this.stopLoading} //.bind(this)
          />
        )}
        {!fwopen && (
          <GridPanel //TODO: Add service and code for remote activity?
            title={stitle}
            sconfig={ServiceConfig}
            sdata={'inspector'}
            rows={cm}
            data={data}
            rowsPerPage={rowsPerPage}
            page={page}
            pageMode={pageMode}
            order={order}
            orderBy={orderBy}
            recordCount={recordCount}
            formatters={_gridformatters}
            actions={_rowActions}
            actionSet={this.props.actionSet}
            rowActions={this.props.rowActions}
            refresh={() => this.refresh()}
            setColumns={this.setColumns}
            filterColumns={this.filterColumns}
            handleSelect={this.handleRecord.bind(this)}
            onAction={this.handleRecord.bind(this)}
            onRowsPerPageChange={this.onRowsPerPageChange}
            onPageChange={this.onPageChange}
            
          />
        )}
      </Box>
    );
  }
}

Inspector.propTypes = {
  service: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  setPage: PropTypes.func,
  setHome: PropTypes.func,
  showNotification: PropTypes.func
};

export default Inspector;
